import { CKCompanyLogo } from '@clearkit/react';

import TwoLineMenuItem from './TwoLineMenuItem';

const SalesforceAccountMenuItem = ({
  salesforceAccount,
  salesforceAccountConnector,
}) => (
  <TwoLineMenuItem
    href={`${salesforceAccountConnector.externalInstanceUrl}/${salesforceAccount.externalId}`}
    icon={
      <CKCompanyLogo
        domain={salesforceAccount.websiteDomain}
        size={32}
        className="shadow-sm"
      />
    }
    externalLinkClass="text-salesforce"
    title={
      <>
        <span className="font-semibold">{salesforceAccount.name}</span> account
      </>
    }
    subtitle={<>Owned by {salesforceAccount?.owner?.name || 'Unknown User'}</>}
  />
);

SalesforceAccountMenuItem.propTypes = {
  salesforceAccount: PropTypes.shape({
    opportunities: PropTypes.array,
    name: PropTypes.string,
    externalId: PropTypes.string,
    websiteDomain: PropTypes.string,
  }),
  salesforceAccountConnector: PropTypes.shape({
    externalInstanceUrl: PropTypes.string,
  }),
};

export default SalesforceAccountMenuItem;
